import { Chip } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { MostRequestHistoryStatus } from 'src/graphql/generated/graphql';

export const StatusField = ({
  status,
}: {
  status: MostRequestHistoryStatus;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'common.status',
  });

  switch (status) {
    case MostRequestHistoryStatus.Completed:
      return <Chip label={t('completed')} color="success" />;
    case MostRequestHistoryStatus.Failed:
      return <Chip label={t('failed')} color="error" />;
    case MostRequestHistoryStatus.Pending:
      return <Chip label={t('pending')} color="warning" />;
    case MostRequestHistoryStatus.Waiting:
      return <Chip label={t('waiting')} color="warning" />;
    case MostRequestHistoryStatus.Processing:
      return <Chip label={t('processing')} color="primary" />;
  }
};
